import React from "react";
import { Link, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

export default function Master() {
  const { pathname } = useLocation();
  const hasAccess = usePrivateLink();
  return (
    <div className="col-2">
      <ul className="list-group shadow">
        {hasAccess("/mess/list") && (
          <Link
            to={"/mess/list"}
            className={`list-group-item ${
              pathname === "/mess/list" && "active"
            }`}
          >
            <i className="ri-hotel-line me-2 ri-20px"></i>
            Mess
          </Link>
        )}
        
        {hasAccess("/mess/enroll/list") && (
          <Link
            to={"/mess/enroll/list"}
            className={`list-group-item ${
              pathname === "/mess/enroll/list" && "active"
            }`}
          >
            <i className="ri-settings-2-line me-2 ri-20px"></i>
            Enrolls
          </Link>
        )}

        {hasAccess("/mess/attendance/list") && (
          <Link
            to={"/mess/attendance/list"}
            className={`list-group-item ${pathname === "/mess/attendance/list" && "active"}`}
          >
            <i className="ri-account-circle-line  me-2 ri-20px"></i>
            Attendance
          </Link>
        )}
      </ul>
    </div>
  );
}
